import { requestService } from '../helpers/request.service';

export const mmPreauthorizationService = {
    getPreauthorization,
    getNoxes,
    getHeader,
    savePreauthorization
}

function getPreauthorization(params) {
    return requestService.get({
        methodName: '/MMPreauthorization/GetPreauthorizationById',
        queryString: params
    });
}

function getHeader(params) {
    return requestService.get({
        methodName: '/MMPreauthorization/GetHeader',
        queryString: params
    });
}

function getNoxes(params) {
    return requestService.get({
        methodName: '/MMPreauthorization/GetNoxes',
        queryString: params
    });
}

function savePreauthorization(params) {
    return requestService.post({
        methodName: '/MMPreauthorization/SavePreauthorization',
        body: params
    });
}
